<div>
  <app-mat-spinner-overlay *ngIf="showSpinner"></app-mat-spinner-overlay>

  <form #df="ngForm" novalidate>
    <div class="row m-0 col-md-12 p-0 formborder">
      <div class="col-md-3">
        <span class="required-lable">From Date</span>
        <div class="datepicker_feild">
          <input [matDatepicker]="picker1" dateConvert placeholder="DD/MM/YYYY" name="FromDate" [(ngModel)]="FromDate"
            #refFromDate="ngModel" [ngClass]="{'is-invalid': df.submitted && refFromDate.invalid}"
            class="form-control input-text-css" required />
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </div>
      </div>

      <div class="col-md-3">
        <span class="required-lable">To Date</span>
        <div class="datepicker_feild">
          <input [matDatepicker]="picker2" dateConvert placeholder="DD/MM/YYYY" name="ToDate" [(ngModel)]="ToDate"
            #refToDate="ngModel" [ngClass]="{'is-invalid': df.submitted && refToDate.invalid}"
            class="form-control input-text-css" required />
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
      </div>

      <div class="col-md-1 justify-content-end">
        <button type="button" (click)="getMAS_EMIPaybleDetails()" class="mt-3 btn font-size-12 button-btn"
          [disabled]="!df.form.valid">
          Search
        </button>

      </div>
      <div class="col-md-2 text-right">
        <button type="button" class="mt-3 btn font-size-12 button-btn"
          (click)="bulkImportTemplate('Direct_NACH_Clearing_Template')">
          Template
        </button>
      </div>
      <div class="col-md-2 text-right">
        <span class="button-wrap">
          <label class="mt-3 btn font-size-12 button-btn" for="bulkImport">Bulk Import</label>
          <input type="file" id="bulkImport" (change)="bulkImport($event)" style="display: none"
            accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
        </span>
      </div>

    </div>
  </form>

  <div class="table-responsive mt-3" *ngIf="dataSource.data.length > 0">

    <mat-table [dataSource]=" dataSource" matSort matTableExporter #exporter="matTableExporter">

      <!-- Serial Number -->
      <ng-container matColumnDef="sno">
        <mat-header-cell class="grid-header" style="max-width: 60px;" *matHeaderCellDef>#</mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
          {{ paginator.pageIndex * paginator.pageSize + (i + 1) }}
        </mat-cell>
        <mat-footer-cell *matFooterCellDef class="grid-header"></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="Partner_LoanAcNo">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Partner Loan
          A/c</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Partner_LoanAcNo }}</mat-cell>
        <mat-footer-cell *matFooterCellDef class="grid-header"></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="Customer_LoanAcNo">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Customer Loan
          A/c</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Customer_LoanAcNo }}</mat-cell>
        <mat-footer-cell *matFooterCellDef class="grid-header"></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="CustomerName">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Customer Name</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">{{ row.CustomerName }}</mat-cell>
        <mat-footer-cell *matFooterCellDef class="grid-header">Total</mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="Period">
        <mat-header-cell mat-sort-header class="grid-header text-right" *matHeaderCellDef>Period</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell text-center">{{ row.Period }}</mat-cell>
        <mat-footer-cell *matFooterCellDef class="grid-header"></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="DueDate">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Due Date</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.DueDate | date:'dd/MM/yyyy' }}
        </mat-cell>
        <mat-footer-cell *matFooterCellDef class="grid-header"></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="EMI_Amount">
        <mat-header-cell mat-sort-header class="grid-header text-right" *matHeaderCellDef>EMI
          Amount</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell text-center">
          {{ row.EMI_Amount }}
        </mat-cell>
        <mat-footer-cell *matFooterCellDef class="text-right grid-header font-weight-bold">
          {{ totaltypewise('EMI_Amount') }}
        </mat-footer-cell>
      </ng-container>
      <ng-container matColumnDef="InstallmentBalance">
        <mat-header-cell mat-sort-header class="grid-header text-right" *matHeaderCellDef>Installment
          Balance</mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell text-center">
          {{ row.InstallmentBalance }}
        </mat-cell>
        <mat-footer-cell *matFooterCellDef class="text-right grid-header font-weight-bold">

        </mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="Clearing_Bounce">
        <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
          Clearing/Bounce
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          <mat-select [(value)]="row.ClearingType" [disabled]="row.Clearinghold"
            style="height: calc(1.3em + 0.25rem + 1px) !important; padding: 0; text-align: center;"
            class="form-control input-text-css" (selectionChange)="ClearingChange($event, row)">

            <mat-option value="">Select</mat-option>
            <mat-option value="Bounce">Bounce</mat-option>
            <mat-option value="Clear">Clear</mat-option>
          </mat-select>
        </mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <!-- Header & Rows -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

      <!-- Footer Row -->
      <mat-footer-row *matFooterRowDef="displayedColumns; sticky: true" class="sticky-footer fontcolor"
        style="background: #4dc3a3; font-weight: bold;">
      </mat-footer-row>

    </mat-table>

    <!-- Export + Paginator -->
    <div class="row m-0 align-items-center mt-3">
      <div class="col-md-4">
        <button class="btn font-size-12 button-btn" (click)="exportTable(exporter)">
          <i class="fa fa-file-export mr-1"></i> Export to Excel
        </button>
      </div>
      <div class="col-md-8">
        <mat-paginator #paginator [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>
      </div>
    </div>

  </div>

  <div class="modal fade in" id="BounceDetailModel" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 10px">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            {{ Type }} Details
          </h6>
          <button type="button" (click)="onCloseBounceDetail()" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>

        <div class="modal-body">
          <form #formRef="ngForm" novalidate class="row m-0 col-md-12 p-0 formborder">

            <!-- Bounce Section -->
            <div class="row m-0 col-md-12 p-0" *ngIf="Type == 'Bounce'">
              <div class="col-md-4">
                <span>Bounce Date</span>
                <input name="BounceDate" [(ngModel)]="BounceDate" required id="BounceDate" placeholder="DD/MM/YYYY"
                  #refBounceDate="ngModel" [min]="Row.PostDate > minDate ? Row.PostDate : minDate" [ngClass]="{
                  'is-invalid': formRef.submitted && refBounceDate.invalid,
                  'alert-warning':
                    refBounceDate.invalid &&
                    (refBounceDate.dirty || refBounceDate.touched || refBounceDate.untouched)
                }" class="form-control input-text-css" bsDatepicker />
              </div>

              <div class="col-md-4">
                <span>Bounce Reason</span>
                <select name="BounceReason" id="BounceReason" #refBounceReason="ngModel" [(ngModel)]="BounceReason"
                  class="form-control input-text-css" required [ngClass]="{
                  'is-invalid': formRef.submitted && refBounceReason.invalid,
                  'alert-warning':
                    refBounceReason.invalid &&
                    (refBounceReason.dirty || refBounceReason.touched || refBounceReason.untouched)
                }">
                  <option value="" selected>Select Bounce Reason</option>
                  <option *ngFor="let BounceR of Bounce_ReasonList" [value]="BounceR.Code">
                    {{ BounceR.Value }}
                  </option>
                </select>
              </div>

              <div class="col-md-4">
                <span>Bounce Charge</span>
                <input name="BounceCharge" [(ngModel)]="BounceCharge" id="refBounceCharge"
                  class="form-control input-text-css" disabled />
              </div>
            </div>

            <!-- Clear Section -->
            <div class="row m-0 col-md-12 p-0" *ngIf="Type == 'Clear'">
              <div class="col-md-4">
                <span>Clear Date</span>
                <div class="datepicker_feild">
                  <input [matDatepicker]="picker14" placeholder="DD/MM/YYYY" name="ClearDate" [(ngModel)]="ClearDate"
                    required id="ClearDate" class="form-control input-text-css" #refClearDate="ngModel"
                    [min]="Row.PostDate > minDate ? Row.PostDate : minDate" [ngClass]="{
                    'is-invalid': formRef.submitted && refClearDate.invalid,
                    'alert-warning':
                      refClearDate.invalid &&
                      (refClearDate.dirty || refClearDate.touched || refClearDate.untouched)
                  }" />
                  <mat-datepicker-toggle matSuffix [for]="picker14"></mat-datepicker-toggle>
                  <mat-datepicker #picker14></mat-datepicker>
                </div>
              </div>
            </div>
            <div class="row m-0 mt-3 col-md-12 p-0 justify-content-end">
              <button type="button" [disabled]="!formRef.form.valid" (click)="Type == 'Bounce' ? onBounce() : onClear()"
                class="btn font-size-12 button-btn">
                Save
              </button>
              <button type="button" (click)="onCloseBounceDetail()" class="btn font-size-12 button-btn">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade in" id="bulkImportModel" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 10px">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            Bulk Import
          </h6>
          <button type="button" (click)="onCloseBulkImport()" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body">
          <div *ngIf="dataSourceUIValidation">
            <h6 class="mb-2">Un Matched Data</h6>
            <div class="table-responsive"
              style="margin-top: 20px; height: fit-content; overflow: auto; border: 1px solid #dc3545;">
              <mat-table [dataSource]="dataSourceUIValidation" matSort matTableExporter #exporterUI="matTableExporter">

                <ng-container matColumnDef="Id">
                  <mat-header-cell *matHeaderCellDef class="grid-header">#</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{ row.Id }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="PartnerLoanNo">
                  <mat-header-cell *matHeaderCellDef class="grid-header">PartnerLoanNo</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell"
                    [style.background-color]="row.partnerLoanNoError ? '#ffcccc' : 'transparent'">
                    {{ row.PartnerLoanNo }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="EMI_Amount">
                  <mat-header-cell *matHeaderCellDef class="grid-header">EMI_Amount</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell"
                    [style.background-color]="row.emiAmountError ? '#ffcccc' : 'transparent'">
                    {{ row.EMI_Amount }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="voucherDate">
                  <mat-header-cell *matHeaderCellDef class="grid-header">voucherDate (DD/MM/YY)</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell"
                    [style.background-color]="row.voucherDateError ? '#ffcccc' : 'transparent'">
                    {{ row.voucherDate }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="DueDate">
                  <mat-header-cell *matHeaderCellDef class="grid-header">DueDate (DD/MM/YY)</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell"
                    [style.background-color]="row.dueDateError ? '#ffcccc' : 'transparent'">
                    {{ row.DueDate }}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ReasonCode">
                  <mat-header-cell *matHeaderCellDef class="grid-header">ReasonCode</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell"
                    [style.background-color]="row.reasonCodeError ? '#ffcccc' : 'transparent'"
                    style="color: #d32f2f; font-weight: bold;">
                    {{ row.ReasonCode }}
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumnsUIValidation"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumnsUIValidation"
                  [style.background-color]="row.hasError ? '#fff2f2' : 'transparent'">
                </mat-row>
              </mat-table>
            </div>
          </div>
          <div *ngIf="dataSourceBulkImport && dataSourceBulkImport.data && dataSourceBulkImport.data.length > 0">
            <h6>Match Data</h6>
            <div class="table-responsive" style="margin-top: 20px; scroll-behavior: auto; height: fit-content">
              <mat-table [dataSource]="dataSourceBulkImport" matSort matTableExporter #exporterTable="matTableExporter">
                <ng-container matColumnDef="Id">
                  <mat-header-cell mat-sort-header class="grid-header" style="width: 50px" *matHeaderCellDef>
                    #
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="width: 50px; max-height: 5px">
                    {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="PartnerLoanNo">
                  <mat-header-cell mat-sort-header class="grid-header mw100"
                    *matHeaderCellDef>PartnerLoanNo</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell mw100">{{
                    row.PartnerLoanNo
                    }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="EMI_Amount">
                  <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>EMI_Amount</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.EMI_Amount
                    }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="voucherDate">
                  <mat-header-cell mat-sort-header class="grid-header mw100"
                    *matHeaderCellDef>voucherDate</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell mw100">{{
                    row.voucherDate
                    }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="DueDate">
                  <mat-header-cell mat-sort-header class="grid-header mw100" *matHeaderCellDef>DueDate</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell mw100">{{
                    row.DueDate
                    }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="ReasonCode">
                  <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>ReasonCode</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.ReasonCode
                    }}</mat-cell>
                </ng-container>


                <mat-header-row *matHeaderRowDef="displayedColumnsBulkImport"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumnsBulkImport"></mat-row>
              </mat-table>

            </div>
            <hr />
            <div class="row m-0 mt-3 col-md-12 p-0 justify-content-end">
              <div class="col-md-8">
                <mat-paginator #paginatorRef [length]="dataSourceBulkImport?.data?.length || 0"
                  [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>
              </div>
              <div>
                <button type="button" (click)="onBulkVoucherSave()" *ngIf="dataSourceBulkImport"
                  [disabled]="MisMatchdata?.length > 0" class="btn font-size-12 button-btn">
                  Save
                </button>
                <button type="button" (click)="onCloseBulkImport()" class="btn font-size-12 button-btn">
                  Cancel
                </button>
              </div>
            </div>
          </div>
          <div
            *ngIf="dataSourceBulkImport_NotMatch && dataSourceBulkImport_NotMatch.data && dataSourceBulkImport_NotMatch.data.length > 0">
            <h6>MisMatch Data</h6>
            <div class="table-responsive" style="margin-top: 20px; scroll-behavior: auto; height: fit-content">
              <mat-table [dataSource]="dataSourceBulkImport_NotMatch" matSort matTableExporter
                #exporterTable1="matTableExporter">
                <ng-container matColumnDef="Id">
                  <mat-header-cell mat-sort-header class="grid-header" style="width: 50px" *matHeaderCellDef>
                    #
                  </mat-header-cell>
                  <mat-cell *matCellDef="let row; let i = index" class="grid-cell" style="width: 50px; max-height: 5px">
                    {{ paginatorRef1.pageIndex * paginatorRef1.pageSize + (i + 1) }}
                  </mat-cell>
                </ng-container>
                <ng-container matColumnDef="PartnerLoanNo">
                  <mat-header-cell mat-sort-header class="grid-header mw100"
                    *matHeaderCellDef>PartnerLoanNo</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell mw100">{{
                    row.PartnerLoanNo
                    }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="EMI_Amount">
                  <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>EMI_Amount</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.EMI_Amount
                    }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="voucherDate">
                  <mat-header-cell mat-sort-header class="grid-header mw100"
                    *matHeaderCellDef>voucherDate</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell mw100">{{
                    row.voucherDate
                    }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="DueDate">
                  <mat-header-cell mat-sort-header class="grid-header mw100" *matHeaderCellDef>DueDate</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell mw100">{{
                    row.DueDate
                    }}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="ReasonCode">
                  <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>ReasonCode</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.ReasonCode
                    }}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="NotMach">
                  <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Not Match
                    Data</mat-header-cell>
                  <mat-cell *matCellDef="let row" class="grid-cell">{{
                    row.NotMach
                    }}</mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumnsNotMatchImport"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumnsNotMatchImport"></mat-row>
              </mat-table>

            </div>

            <div class="col-md-12 p-0 mt-1 text-right">
              <div class="col-md-8">
                <mat-paginator #paginatorRef1 length]="dataSourceBulkImport_NotMatch?.data?.length || 0"
                  [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>
              </div>
              <button type="button" (click)="onExportMisMatch(exporterTable1)" class="btn font-size-12 button-btn">
                Export MisMatch data
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>